import { render, staticRenderFns } from "./FiltroRetencao.vue?vue&type=template&id=2f0b4c9d"
import script from "./FiltroRetencao.vue?vue&type=script&lang=js"
export * from "./FiltroRetencao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports